/**
 * @author      hugo@zumper.com (Hugo Pineda)
 * @copyright   Copyright (c) 2023, Zumper
 */

import type {
  CLSAttribution,
  INPAttribution,
  LCPAttribution,
  MetricWithAttribution,
} from 'web-vitals/attribution'

import { getCLSDebugTarget } from './getCLSDebugTarget'
import { getInteractionTarget } from './getInteractionTarget'

export interface GetEventLabelProps {
  attribution: MetricWithAttribution['attribution']
  entries: MetricWithAttribution['entries']
  id: string
  name: MetricWithAttribution['name']
}

export const getEventLabel = ({
  attribution,
  entries,
  id,
  name,
}: GetEventLabelProps) => {
  switch (name) {
    case 'CLS':
      return (
        (attribution as CLSAttribution).largestShiftTarget ||
        getCLSDebugTarget(entries) ||
        id
      )
    case 'INP':
    case 'FID':
      return (
        (attribution as INPAttribution).interactionTarget ||
        getInteractionTarget(entries as PerformanceEventTiming[]) ||
        id
      )
    case 'LCP':
      return (attribution as LCPAttribution).element || id
    default:
      return id
  }
}
